import { render, staticRenderFns } from "./DocusignEditAdditionalDocument.vue?vue&type=template&id=10c9fea1&"
import script from "./DocusignEditAdditionalDocument.vue?vue&type=script&lang=ts&"
export * from "./DocusignEditAdditionalDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports